import { useCartAndDeliveryDatesDataContext } from '@app/data/clients/cartCheckoutClient';
import { ShippingMethod } from '@app/types/cart/ShippingMethod';

export const useShippingMethod = () => {
  const { cart } = useCartAndDeliveryDatesDataContext();
  const shippingEstimates = cart?.summary.estimated_shipping;
  return shippingEstimates?.preference === 'express'
    ? ShippingMethod.Express
    : ShippingMethod.Standard;
};
